module.exports = __webpack_public_path__ + "static/media/In_Depth_Hero_Desktop_1.98f233f0.png";